import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PartsOrder, PartsOrderStatus } from '@contracts/interfaces/parts-order.interface';
import { TaskService } from '../../services/task.service';
import { Task } from '@contracts/interfaces/task.interface';

@Component({
  selector: 'app-parts-order-dialog',
  templateUrl: './parts-order.dialog.html',
  styleUrls: ['./parts-order.dialog.scss']
})
export class PartsOrderDialog {

  public order: PartsOrder;
  public statuses = [
    PartsOrderStatus.ORDERED,
    PartsOrderStatus.RECEIVED,
    PartsOrderStatus.BACKORDERED,
    PartsOrderStatus.CANCELLED
  ];
  public taskHint: string | null = null;
  public taskError: string | null = null;
  public isCheckingTask = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<PartsOrderDialog>,
    public dialog: MatDialog,
    private taskService: TaskService,
  ) {
    this.order = data?.order ? { ...data.order } : {
      title: '',
      status: PartsOrderStatus.ORDERED,
      quantity: 1
    };
  }

  onTaskBlur() {
    this.taskHint = null;
    this.taskError = null;

    const taskId = Number(this.order.taskId);
    if (!taskId) {
      return;
    }

    this.isCheckingTask = true;
    this.taskService.get(taskId).subscribe({
      next: (task: Task | null) => {
        if (task) {
          this.taskHint = task.subject;
        } else {
          this.taskError = 'Task not found';
        }
        this.isCheckingTask = false;
      },
      error: () => {
        this.taskError = 'Unable to validate task';
        this.isCheckingTask = false;
      }
    });
  }

  save() {
    this.dialogRef.close(this.order);
  }

  markReceived() {
    this.order.status = PartsOrderStatus.RECEIVED;
    this.order.receivedDate = new Date();
    this.save();
  }

  cancel() {
    this.dialogRef.close(null);
  }
}
